import React from 'react';
import Icon from '../../../components/AppIcon';

const DisclaimerHeader = () => {
  return (
    <div className="bg-error/10 border-b-2 border-error p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 bg-error rounded-full p-3">
          <Icon name="AlertTriangle" size={32} color="#FFFFFF" />
        </div>
        <div className="flex-1">
          <h1 className="text-2xl font-bold text-foreground mb-2">
            Legal Disclaimer & Terms Agreement
          </h1>
          <p className="text-error font-semibold mb-2">
            ⚠️ IMPORTANT: READ CAREFULLY BEFORE PROCEEDING
          </p>
          <p className="text-sm text-muted-foreground">
            By creating a BOLTPay account, you acknowledge and accept the following terms, 
            disclaimers, and limitations of liability. This agreement is legally binding.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerHeader;